<!-- @format -->

<info-identity-tag>

  <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">身分証明書<span class="status_label status_label-required margin-spacing-2_left"></span></h2>

  <p class="text">ご本人確認の為の書類として身分証明書の提出が必要です。<br>下記の表の「<strong>本人確認書類</strong>」の<strong>いずれか1種類</strong>を提出する書類として選択いただき、「<strong>提出するページ</strong>」の画像をアップロードしてください。</p>
  <p class="note margin-spacing-1_top">※下記の表に記されているもの以外の書類を利用されたい場合は、<a href="https://edilent.biz-samurai.com/menu/inquiry" target="_blank" rel="noopener">こちら</a>より事務局にお問い合わせください。</p>
  <p class="note margin-spacing-1_top">※全体が写っていない、あるいは文字が読み取れないなど、不備がある場合は、再申請をお願いすることとなりますのでご注意ください。</p>

  <table class="documents_table margin-spacing-3_top">
    <tr>
      <th class="documents_table-document">本人確認書類</th>
      <th class="documents_table-page">提出するページ</th>
      <th class="documents_table-caution">注意事項</th>
    </tr>
    <tr>
      <th class="heading02">パスポート</th>
      <td>
        ①顔写真入りページ<br>②住所記入欄ページ
      </td>
      <td>2020年2月4日以降に発給申請されたパスポートは、現住所の記載がないため身分証明書としてご利用いただけません。2020年2月3日以前に発給申請された、日本国発行の有効期限内のパスポートをご利用ください。
      </td>
    </tr>
    <tr>
      <th class="heading02">運転免許証</th>
      <td>
        ①おもて面<br>②うら面
      </td>
      <td>有効期限内の運転免許証をご利用ください。</td>
    </tr>
    <tr>
      <th class="heading02">マイナンバーカード</th>
      <td>
        ①おもて面<br>②うら面
      </td>
      <td>個人番号通知書および通知カードは身分証明書としてご利用いただけません。</td>
    </tr>
    <tr>
      <th class="heading02">特別永住者証明書</th>
      <td>
        ①おもて面<br>②うら面
      </td>
      <td>有効期限内の特別永住者証明書をご利用ください。</td>
    </tr>
    <tr>
      <th class="heading02">障がい者手帳（カード含む）</th>
      <td>
        ①おもて面<br>②うら面<br>※手帳の場合は表紙と個人情報部分
      </td>
      <td>顔写真付きの有効期限内のもので、マイナンバーの照合書類と住所が一致している物。<br>※手帳型で住所変更等の記載がある場合は、顔写真部分と変更情報記載部分をアップロードしてください。</td>
    </tr>

</table>

  <h3 class="heading-04 margin-spacing-5_top">本人確認書類</h3>
  <table class="detail_table">
    <tr class="detail_table-row">
      <th class="information_table-heading">提出する書類</th>
      <td class="information_table-data">
        <div class="box_flex02">
          <div class="box_w60">
            <div class="sort-menu">
              <select name="identity_type" class="sort-list" is="binding-tag" onchange={(e)=>changeType(e)}>
                <option value="{key}" each={key in Object.keys(state.types)}>{state.types[key]}</option>
              </select>
            </div><!--/.sort-menu-->
          </div>
        </div>	
      </td>
    </tr>
  </table>

  <h3 class="heading-04 margin-spacing-2_bottom margin-spacing-3_top">{state.types[basicInformation.item.identity_type]}：提出するページ①</h3>
					
  <img-tag name={'file1'}></img-tag>
  <div class="box_flex03 margin-spacing-1_top margin-spacing-1_bottom">
    <div 
      class="button button-secondary button-file" 
      type="button" 
      name="file1"
      value="ファイルを選択"
      onclick="{ uploadImg1 }"
      data-target=""
      >ファイルを選択</div>
  </div>
  
  <h3 class="heading-04 margin-spacing-2_bottom margin-spacing-3_top">{state.types[basicInformation.item.identity_type]}：提出するページ②</h3>
  
  <img-tag name={'file2'}></img-tag>
  <div class="box_flex03 margin-spacing-1_top margin-spacing-1_bottom">
    <div 
      class="button button-secondary button-file" 
      type="button" 
      name="file2"
      value="ファイルを選択"
      onclick="{ uploadImg2 }"
      data-target=""
      >ファイルを選択</div>
  </div>

  <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">マイナンバー
    <span class="status_label status_label-required margin-spacing-2_left"></span>
  </h2>

  <p class="text">ご入力いただいた内容は、源泉処理で利用いたします。<br>
  マイナンバー確認画像欄には入力内容を照合するためのマイナンバーカード、または個人番号通知書のナンバー記載部分と氏名、住所等の記載部分の画像をアップロードしてください。</p>
  <table class="detail_table">
    <tr class="detail_table-row">
      <th class="information_table-heading">マイナンバー</th>
      <td class="information_table-data">
        <div class="inner_form field">

          <label class="form-heading" for="mynumber">マイナンバー記載欄（12桁）</label>
          <input 
            class="text_input margin-spacing-3_bottom" 
            type="text"
            maxlength='12'
            name="mynumber" 
            is="binding-tag"
            errmsg="マイナンバーを12桁の半角数字で入力してください"
          >
        </div><!--/.inner_form-->
      </td>
    </tr>
  </table>


  <h3 class="heading-04 margin-spacing-2_bottom margin-spacing-3_top">マイナンバー確認画像：表</h3>

  <img-tag name={'file3'}></img-tag>
  <div class="box_flex03 margin-spacing-1_top margin-spacing-1_bottom">
    <div 
      class="button button-secondary button-file" 
      type="button" 
      name="file3"
      value="ファイルを選択"
      onclick="{ uploadImg3 }"
      data-target=""
      >ファイルを選択</div>
  </div>

  <h3 class="heading-04 margin-spacing-2_bottom margin-spacing-3_top">マイナンバー確認画像：裏</h3>

  <img-tag name={'file4'}></img-tag>
  <div class="box_flex03 margin-spacing-1_top margin-spacing-1_bottom">
    <div 
      class="button button-secondary button-file" 
      type="button" 
      name="file4"
      value="ファイルを選択"
      onclick="{ uploadImg4 }"
      data-target=""
      >ファイルを選択</div>
  </div>

<script>
  import di from "dependency-injection";
  import bindingTag from "@tags/parts/info/basic-information/binding.riot";
  import basicInformation from "@model/basicInformation/api";
  import imgTag     from "@tags/parts/info/basic-information/image.riot";

  export default {
    components: {
      'binding-tag': bindingTag,
      'img-tag': imgTag,
    },
    basicInformation: basicInformation,
    state:{
      type: "driver-lisence",
      types: {
        "driver-lisence": "運転免許証",
        "passport": "パスポート",
        "my-number-card": "マイナンバーカード",
        "immigration": "特別永住者証明書",
      },
    },
    changeType(e) {
      this.basicInformation.item.identity_type = e.target.value
      this.state.type =  e.target.value
      this.update();
    },
    uploadImg1(e) {
      e.preventDefault()
      this.basicInformation.trigger('upload-img_file1')
    },    
    uploadImg2(e) {
      e.preventDefault()
      this.basicInformation.trigger('upload-img_file2')
    },    
    uploadImg3(e) {
      e.preventDefault()
      this.basicInformation.trigger('upload-img_file3')
    },
    uploadImg4(e) {
      e.preventDefault()
      this.basicInformation.trigger('upload-img_file4')
    }
  }
</script>
</info-identity-tag>
